import { Link, useNavigate } from "react-router-dom";
import { Icon } from "./Icon";
import { ArrowButton } from "./arrowButton";

interface NewUserInfoProps {
  setIsOpenMyPageSidebar: (value: boolean) => void;
}

export const NewUserInfo: React.FC<NewUserInfoProps> = (props) => {
  const { setIsOpenMyPageSidebar } = props;
  const navigate = useNavigate();
  const pageLinks = [
    {
      name: "サンバについて",
      href: "/top",
    },
    {
      name: "はじめ方",
      href: "https://half-pressure-b6c.notion.site/1a6941dfbe40801295d4d6778c4457bb?pvs=4",
    },
    {
      name: "ゲーム説明・遊び方",
      href: "https://half-pressure-b6c.notion.site/1a6941dfbe4080f18d01ddf1958e51ee?pvs=4",
    },
    {
      name: "安心安全の取り組みについて",
      href: "https://thumba.jp/media/216",
    },
    {
      name: "ヘルプ",
      href: "https://half-pressure-b6c.notion.site/1a6941dfbe408057ba5afe0e9566b691?v=1a6941dfbe408139805a000c5955c327&pvs=4",
    },
  ];

  const showPageLinks = ({
    name,
    href,
  }: {
    name: string;
    href: string;
  }): JSX.Element => {
    if (href.startsWith("/")) {
      if (href === "/top") {
        return (
          <div
            onClick={() => {
              navigate("/top", { state: { isViewedTop: true } });
              setIsOpenMyPageSidebar(false);
            }}
            className="hover:cursor-pointer border-t border-gray-200 border-solid py-[17px] flex items-center justify-between w-full"
          >
            <div className="text-base font-medium">{name}</div>

            <div>
              <div className="w-full">
                <ArrowButton className="rotate-90" />
              </div>
            </div>
          </div>
        );
      }

      return (
        <Link
          to={href}
          state={{ hideStartButton: true }}
          className="hover:cursor-pointer border-t border-gray-200 border-solid py-[17px] flex items-center justify-between w-full"
        >
          <div className="text-base font-medium">{name}</div>

          <div>
            <div className="w-full">
              <ArrowButton className="rotate-90" />
            </div>
          </div>
        </Link>
      );
    }
    return (
      <a
        href={href}
        target="_blank"
        className="hover:cursor-pointer border-t border-gray-200 border-solid py-[17px] flex items-center justify-between w-full"
        rel="noreferrer"
      >
        <div className="text-base font-medium">{name}</div>

        <div>
          <div className="w-full">
            <ArrowButton className="rotate-90" />
          </div>
        </div>
      </a>
    );
  };

  return (
    <div className="flex flex-col gap-[26px] items-start pt-[39px] border-b border-gray-200 border-solid">
      <div className="flex items-center gap-1">
        <Icon src="/assets/wakaba-mark.svg" imageSize={{ width: "30", height: "30" }} />
        <p className="text-lg font-semibold -tracking-[.01em]">初めての方へ</p>
      </div>
      <div className="flex flex-col items-start w-full">
        {pageLinks.map((pageLink) => {
          return showPageLinks({ name: pageLink.name, href: pageLink.href });
        })}
      </div>
    </div>
  );
};
